import script from "./EditorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorView.vue?vue&type=script&setup=true&lang=ts"

import "./EditorView.vue?vue&type=style&index=0&id=4cbed81c&lang=css"

const __exports__ = script;

export default __exports__